export enum CaregiverRelationHelper {
  PARTNER = 'partner',
  PARENT = 'sibling',
  CHILD = 'child',
  OTHER = 'other',
}

export const caregiverRelationMapping = {
  [CaregiverRelationHelper.PARTNER]: $localize`:@@common_caregiverRelation_partner:Partner`,
  [CaregiverRelationHelper.PARENT]: $localize`:@@common_caregiverRelation_parent:Parent`,
  [CaregiverRelationHelper.CHILD]: $localize`:@@common_caregiverRelation_child:Child`,
  [CaregiverRelationHelper.OTHER]: $localize`:@@common_caregiverRelation_other:Other`,
};
